import type {
  ICreateOptOutPeriodBody,
  ICreateProgramEnrollmentsBody,
  IEditProgramEnrollmentBody,
  IISOEnergyProgram,
  IOptOutPeriod,
  IOptOutPeriodFilters,
  IProgramEnrollment,
  IProgramEnrollmentFilters,
  ISiteEnrollmentGroup,
} from '@/types/eos/ProgramEnrollment'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

export async function getISOEnergyPrograms(): Promise<IISOEnergyProgram[]> {
  const response = await axios.get<IISOEnergyProgram[]>(`${import.meta.env.VITE_APP_EOSS_API}/iso-energy-programs`)
  return response.data
}

export async function getProgramEnrollments(
  filters: Partial<IProgramEnrollmentFilters>
): Promise<ISiteEnrollmentGroup[]> {
  const response = await axios.get<ISiteEnrollmentGroup[]>(`${import.meta.env.VITE_APP_EOSS_API}/program-enrollments`, {
    params: filters,
  })
  return response.data
}

export async function createProgramEnrollments(body: ICreateProgramEnrollmentsBody): Promise<void> {
  await axios.post(`${import.meta.env.VITE_APP_EOSS_API}/program-enrollments`, body)
}

export async function editProgramEnrollment(id: number, body: IEditProgramEnrollmentBody): Promise<IProgramEnrollment> {
  const response = await axios.put<IProgramEnrollment>(
    `${import.meta.env.VITE_APP_EOSS_API}/program-enrollments/${id}`,
    body
  )
  return response.data
}

export async function deleteProgramEnrollment(id: number): Promise<void> {
  await axios.delete(`${import.meta.env.VITE_APP_EOSS_API}/program-enrollments/${id}`)
}

export async function createOptOutPeriod(
  programEnrollmentId: number,
  body: ICreateOptOutPeriodBody
): Promise<IOptOutPeriod> {
  const response = await axios.post<IOptOutPeriod>(
    `${import.meta.env.VITE_APP_EOSS_API}/program-enrollments/${programEnrollmentId}/opt-out-periods`,
    body
  )
  return response.data
}

export async function deleteOptOutPeriod(programEnrollmentId: number, optOutPeriodId: number): Promise<void> {
  await axios.delete(
    `${import.meta.env.VITE_APP_EOSS_API}/program-enrollments/${programEnrollmentId}/opt-out-periods/${optOutPeriodId}`
  )
}

export async function getOptOutPeriods(
  programEnrollmentId: number,
  filters: IOptOutPeriodFilters
): Promise<IPage<IOptOutPeriod>> {
  const response = await axios.get<IPage<IOptOutPeriod>>(
    `${import.meta.env.VITE_APP_EOSS_API}/program-enrollments/${programEnrollmentId}/opt-out-periods`,
    { params: filters }
  )
  return response.data
}
